import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { onAuthStateChanged } from "firebase/auth";
import HomeView from "@/views/HomeView.vue";
import DashboardView from "@/views/DashboardView.vue";
import LoginView from "@/views/LoginView.vue";
import TrainingVideoDashboardView from "@/views/Training/Video/TrainingSessionVideoDashboardView.vue";
import AufgabenView from "@/views/AufgabenView.vue";
import Fehler404View from "@/views/Fehler/Fehler404View.vue";
import { doc, getDoc } from "firebase/firestore";
import { firebaseAuth, firebaseDb } from "@/main";
import RudertechnikView from "@/views/RudertechnikView.vue";
import EinstellungenView from "@/views/EinstellungenView.vue";
import TrainingSessionMapView from "@/views/Training/Map/TrainingSessionMapView.vue";
import { User } from "firebase/auth";
import TrainingSessionVideoView from "@/views/Training/Video/TrainingSessionVideoView.vue";
import TrainingAuswahlView from "@/views/Training/TrainingAuswahlView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { requiresAuth: false },
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { requiresAuth: false },
  },
  {
    path: "/rudertechnik",
    name: "Rudertechnik",
    component: RudertechnikView,
    meta: { requiresAuth: true },
  },
  {
    path: "/aufgaben",
    name: "Aufgaben",
    component: AufgabenView,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/einstellungen",
    name: "Einstellungen",
    component: EinstellungenView,
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: "/training",
    name: "TrainingAuswahl",
    component: TrainingAuswahlView,
    meta: { requiresAuth: true },
  },
  {
    path: "/training/map",
    name: "TrainingSessionMapView",
    component: TrainingSessionMapView,
    meta: { requiresAuth: true },
  },
  {
    path: "/training/video/dashboard",
    name: "TrainingVideoDashboardView",
    component: TrainingVideoDashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: "/training/video/session/:id/:videoUrl/:videoId/:baseSpeed/:videobeginn/:videodauer/:videotitel/:trainingsmethode",
    name: "TrainingSessionVideoView",
    component: TrainingSessionVideoView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Fehler404View",
    component: Fehler404View,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const user = firebaseAuth.currentUser;

  if (user) {
    if (to.path === "/") {
      return next("/dashboard");
    }
    return next();
  }

  if (to.meta.requiresAuth) {
    try {
      const authUser = await new Promise<User | null>((resolve) => {
        const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
          unsubscribe(); // Direkt das Event wieder abmelden
          resolve(user);
        });
      });

      if (authUser) {
        if (to.meta.requiresAdmin) {
          let userDocSnap = null;

          if (authUser && "uid" in authUser) {
            const userDocRef = doc(
              firebaseDb,
              "benutzer",
              (authUser as User).uid
            );

            userDocSnap = await getDoc(userDocRef);
          }

          if (
            userDocSnap &&
            userDocSnap.exists() &&
            userDocSnap.data().istAdmin
          ) {
            return next();
          } else {
            return next({ name: "Fehler404View" });
          }
        }

        return next();
      } else {
        return next("/");
      }
    } catch (error) {
      console.error("Fehler bei der Authentifizierung:", error);
      return next("/");
    }
  }

  return next();
});

export default router;
